<!-- Page Header -->
<div class="mb-6 flex flex-wrap items-center justify-between gap-4">
    <!-- Title area -->
    <div>
        <h1
            #titleEl
            animate.enter="page-title-enter"
            class="text-2xl font-bold text-slate-800"
        >
            {{ pageTitle || '&#8203;' }}
        </h1>
        @if (pageSubtitle) {
            <p
                #subtitleEl
                animate.enter="page-title-enter"
                class="mt-1 text-slate-500"
            >
                {{ pageSubtitle }}
            </p>
        }
    </div>

    <!-- Tools area -->
    <div class="flex items-center gap-3">
        <ng-content select="[tools]"></ng-content>
    </div>
</div>

<!-- Content Card -->
<div>
    <ng-content select="[content]"></ng-content>
</div>
